const BUCKET_LABELS = {
  livingEssentials: "Living Essentials",
  lifestyleSpending: "Lifestyle Spending",
  liquidity: "Oxygen Tanks / Liquidity",
  diversifiedInvestments: "Diversified Investments",
  educationAndGrowth: "Education & Growth",
}

const GBP_FORMATTER = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 0,
})

function formatGbp(value) {
  return GBP_FORMATTER.format(Number(value) || 0)
}

export function LifestyleSummary({ summary }) {
  const targetValues = [
    ["Post-tax target", `${formatGbp(summary.postTaxMonthly)}/mo`],
    ["Gross estimate", `${formatGbp(summary.grossMonthly)}/mo`],
  ]

  return (
    <div className="mt-3 space-y-3 border-t border-border pt-3">
      <div>
        <p className="text-[10px] font-semibold uppercase text-muted-foreground">
          {summary.splitName} money buckets
        </p>
        <div className="mt-2 grid grid-cols-2 gap-2">
          {targetValues.map(([label, value]) => (
            <div key={label}>
              <p className="text-[10px] text-muted-foreground">{label}</p>
              <p className="mt-1 font-bold text-foreground">{value}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="space-y-1 border-t border-border pt-2">
        {Object.entries(summary.bucketAmounts || {}).map(([key, value]) => (
          <div key={key} className="flex items-center justify-between gap-3">
            <span className="text-muted-foreground">{BUCKET_LABELS[key] || key}</span>
            <span className="font-semibold text-foreground">{formatGbp(value)}</span>
          </div>
        ))}
      </div>
      <p className="border-t border-border pt-2 text-[10px] text-muted-foreground">
        Tax year {summary.taxYear}. Estimate assumes one UK limited-company director/shareholder.
      </p>
    </div>
  )
}
